import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 16.5,
  r: 2.5
});

var SvgMenu = function SvgMenu(props) {
  return _ref;
};

export default SvgMenu;